import { render, staticRenderFns } from "./Scarf.vue?vue&type=template&id=0259d99a&"
import script from "./Scarf.vue?vue&type=script&lang=js&"
export * from "./Scarf.vue?vue&type=script&lang=js&"
import style0 from "./Scarf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports